import React, { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { formMetadataState, userState } from 'state';
import { PostLog, ERROR, INFO } from 'api';

export function ErrorBoundary({ children }) {

	const [errors, setErrors] = useState([]);
	const { sysAppname, name, url } = useRecoilValue(formMetadataState);
	const { username } = useRecoilValue(userState);

	useEffect(() => {
		window.onerror = async (message, file, line, column, errorObject) => {
			try {
				column = column || (window.event && window.event.errorCharacter);
				var stack = errorObject ? errorObject.stack : null;

				// Stack from IE
				if (!stack) {
					var stack = [];
					var f = arguments.callee.caller;
					while (f) {
						stack.push(f.name);
						f = f.caller;
					}
					errorObject['stack'] = stack;
				}

				var data = {
					message,
					file,
					line,
					column,
					errorStack: stack,
				};
				const res = await PostLog({
					Level: INFO,
					Message: message,
					Exception: `file: ${file}, line: ${line}, column: ${column}`,
					AppName: sysAppname,
					username: username,
					ModuleName: url,
					IsFrontend: true,
				});
				setErrors((prev) => [...prev, data]);
			} catch (error) {
				const res = await PostLog({
					Level: ERROR,
					Message: error.message,
					Exception: null,
					AppName: sysAppname,
					username: username,
					ModuleName: url,
					IsFrontend: true,
				});
				console.warn(error);
			}
		};
		return () => {};
	}, [sysAppname, name, url, username]);

	if (errors.length > 0)
		return (
			<>
				<h1>Pri delovanju je prišlo do napake.</h1>
				<ul>
					{errors.map((error, i) => (
						<li key={i}>
							{error.line} ({error.file}): {error.message}
						</li>
					))}
				</ul>
			</>
		);
	return children;
}
